import { render, staticRenderFns } from "./ask-reply.vue?vue&type=template&id=763b323e&scoped=true"
import script from "./ask-reply.vue?vue&type=script&lang=js"
export * from "./ask-reply.vue?vue&type=script&lang=js"
import style0 from "./ask-reply.vue?vue&type=style&index=0&id=763b323e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763b323e",
  null
  
)

export default component.exports